import {
  useGetIdentity,
  useGetList,
  useListContext,
  useResourceContext,
  useTranslate,
} from "ra-core";
import { List } from "@/components/admin/list";

import type { OutreachList, OutreachListMember } from "../types";
import { OutreachListCard } from "./OutreachListCard";

export const OutreachListList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={false}
      pagination={false}
    >
      <OutreachListListLayout />
    </List>
  );
};

const OutreachListListLayout = () => {
  const { data, isPending } = useListContext<OutreachList>();
  const translate = useTranslate();
  const resource = useResourceContext();
  const { data: activeMembers } = useGetList<OutreachListMember>(
    "outreach_list_members",
    {
      filter: { "removed_at@is": null },
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
    },
  );

  if (isPending) return null;

  const countsByList = (activeMembers ?? []).reduce<Record<string, number>>(
    (acc, member) => {
      const key = String(member.list_id);
      acc[key] = (acc[key] ?? 0) + 1;
      return acc;
    },
    {},
  );

  return (
    <div className="mt-2 mb-2 flex flex-col gap-4">
      <h1 className="text-xl font-semibold">
        {translate(`resources.${resource}.name`, {
          smart_count: 2,
          _: resource === "channels" ? "Channels" : "Offer",
        })}
      </h1>
      <div className="flex flex-col gap-3">
        {data?.map((list) => (
          <OutreachListCard
            key={list.id}
            list={list}
            activeCount={countsByList[String(list.id)] ?? 0}
          />
        ))}
      </div>
    </div>
  );
};
